import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../_services/auth/authentication.service";
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AvatarComponent } from './avatar/avatar.component';
import { UserService } from "../../_services/user/user.service";
import { LocalStorageService } from "../../_services/localStorage/local-storage.service";
import { NavigationEnd, Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter } from 'rxjs/operators';
import { DASHBOARD_MENU_CONFIG, MenuItem } from '../../_helpers/dashboardMenu.config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  // Sidebar & Menu
  isExpanded = false;
  menuFlag: string = 'Home';
  sidebarsmaller = false;
  sidebarbigger = false;

  menuItems: MenuItem[] = [];

  // User & Tenant Data
  retrievedImage: any;
  image: any;
  tenantId: string;
  currentUser: any;
  adminFlag: boolean;
  userDetails: any;

  // Flags
  isTenantCustomised = false;
  allowed = false

  //isAdmin: boolean;
  isItUser: boolean;
  isItAdmin: boolean;
  isHelpdeskAdmin: boolean;
  isHelpdeskUser: boolean;
  isHrAdmin: boolean;
  isFinanceAdmin: boolean;
  isFinanceUser: boolean;
  isCrmAdmin: boolean;
  isCrmUser: boolean;
  isPmoUser: boolean;
  isPmoAdmin: boolean;
  isPmoManager: boolean;
  isAdministrator: boolean;
  isNDAAdmin: boolean;
  isApprover: boolean;
  isAdministration: boolean;
  isHRMUser: boolean;

  private customisedTenants = ['imtechnologies', 'pragamana'];
  roleFlags: Record<string, boolean> = {}; // Role-based flags

  constructor(
    public loginService: AuthenticationService,
    public dialog: MatDialog,
    private storageService: LocalStorageService,
    private router: Router,
    private snackbar: MatSnackBar
  ) {
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));     // Load user info
    this.userDetails = this.currentUser;
    this.tenantId = this.storageService.get('tenantId');    // Load tenant info
    this.allowed = this.currentUser.roles.includes('Administrator'); // check if roles list has 'Administrator' in it
    this.adminFlag = this.currentUser.admin;  // check tenant admin flag
    // Restore menuFlag if available
    this.menuFlag = this.storageService.get('activeMenu') || 'Home';
  }

  ngOnInit(): void {
    this.getImage();
    this.setRoleFlags();
    this.filterMenus();

    // this.setTenantFlags();
    // Auto-detect menu from current route on refresh
    this.setMenuFromUrl(this.router.url);

    // Keep updating menuFlag when navigating between pages
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.setMenuFromUrl(event.urlAfterRedirects);
    });
  }

  setRoleFlags(){
    const roles = this.currentUser.roles;
    // this.isAdmin = roles.includes('RoleITAdministrator');
    this.isItUser = roles.includes('RoleITUser');
    this.isItAdmin = roles.includes('RoleITAdministrator');
    this.isHelpdeskUser = roles.includes('RoleHelpdeskUser');
    this.isHelpdeskAdmin = roles.includes('RoleHelpdeskAdmin');
    this.isHrAdmin = roles.includes('RoleHrmAdministrator');
    this.isHRMUser = roles.includes('RoleHrmUser');
    this.isFinanceAdmin = roles.includes('RoleFinanceAdministrator');
    this.isFinanceUser = roles.includes('RoleFinanceUser');
    this.isCrmAdmin = roles.includes('RoleCrmAdministrator');
    this.isCrmUser = roles.includes('RoleCrmUser');
    this.isPmoAdmin = roles.includes('RolePmoAdministrator');
    this.isPmoManager = roles.includes('RolePmoManager');
    this.isPmoUser = roles.includes('RolePmoUser');
    this.isAdministrator = roles.includes('RoleAdministrator');
    this.isApprover = roles.includes('RoleApprover');
    this.isNDAAdmin = roles.includes('RoleNDATeam');
    this.isAdministration = roles.includes('RoleAdministrationUser');
  }

  filterMenus(){
    const flags = this;
    this.menuItems = DASHBOARD_MENU_CONFIG.filter(menu =>
      ((!menu.allowedRoles ||
        menu.allowedRoles.includes('all') ||
        menu.allowedRoles.some(r => (flags as any)[r])) &&
       (!menu.allowedTenants ||
        menu.allowedTenants.includes('all') ||
        menu.allowedTenants.includes(this.tenantId)))
    ).map(menu => ({
      ...menu,
      subMenus: menu.subMenus?.filter(sub =>
        ((!menu.allowedRoles ||
          sub.allowedRoles.includes('all') ||
          sub.allowedRoles.some(r => (flags as any)[r])) && 
         (!menu.allowedTenants ||
          sub.allowedTenants.includes('all') ||
          sub.allowedTenants.includes(this.tenantId)))
      )
    }));
  }

  onMenuClick(menu: any) {
    if (menu.subMenus?.length) {
      menu.expanded = !menu.expanded;
    } else {
      this.navigate(menu.route);
    }
  }

  navigate(route: string, event?: MouseEvent) {
    if (event) event.stopPropagation();
    if (!route) return;
  
    this.router.navigate([`${this.tenantId}/dashboard/${route}`]);
  }

  /** Set Tenant Customisation Flags */
  private setTenantFlags() {
    this.isTenantCustomised = this.customisedTenants.includes(this.tenantId);
  }

  /** Map URL → Active Menu */
  private setMenuFromUrl(url: string): void {
    if (url.includes('/itm')) {
      this.menuFlag = 'ITM';
    } else if (url.includes('/hr')) {
      this.menuFlag = 'HRM';
    } else if (url.includes('/project')) {
      this.menuFlag = 'Project Management';
    } else if (url.includes('/resource-utilization')) {
      this.menuFlag = 'Project Management';
    } else if (url.includes('/adminstration')) {
      this.menuFlag = 'Adminstration';
    } else if (url.includes('/finance')) {
      this.menuFlag = 'Finance';
    } else if (url.includes('/crm')) {
      this.menuFlag = 'CRM';
    } else if (url.includes('/approval')) {
      this.menuFlag = 'My Approval';
    } else if (url.includes('/index')) {
      // For CRM, Admin, Finance, My Approval → read from localStorage
      this.menuFlag = this.storageService.get('activeMenu') || 'Home';
    } else {
      this.menuFlag = 'Home';
    } 

    // Save current active menu in localStorage
    this.storageService.set('activeMenu', this.menuFlag);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AvatarComponent);
    dialogRef.afterClosed().subscribe(() => this.getImage() );
  }

  getImage() {
    this.image = JSON.parse(this.storageService.get('userImage'));
    if (this.image !== null) {
      this.retrievedImage = 'data:image/jpeg;base64,' + this.image;
    } else {
      this.retrievedImage = './assets/user-icon-jpg-29.jpg';
    }
  }

  changeMenu(e) {
    let roles = this.currentUser.roles;

    const menuMap: Record<number, string> = {
      1: 'Project Management',
      2: 'CRM',
      3: 'HRM',
      4: 'ITM',
      5: 'Adminstration',
      7: 'My Approval',
      8: 'Finance',
      9: 'Recruit',
    };

    const menuName = menuMap[e] || 'Home';
    this.menuFlag = menuName;
    this.storageService.set('activeMenu', menuName);

    if (!this.isPermitted(e)) {
      this.openNotAuthorizedSnackbar();
      return;
    }
    switch (+e) {
      case 1:
        this.menuFlag = "Project Management";
        if (roles.includes("RolePmoAdministrator") || roles.includes("RolePmoManager") || roles.includes('isAdministration')) {
          this.router.navigate([this.tenantId + '/dashboard/project/pmoDashboard']);
        } else {
          this.router.navigate([this.tenantId + '/dashboard']);
        }
        break;
      case 2:
        this.menuFlag = "CRM";
        this.router.navigate([this.tenantId + '/dashboard']);
        break;
      case 3:
        this.menuFlag = "HRM";
        if (roles.includes("RoleHrmAdministrator")) {
          this.router.navigate([this.tenantId + '/dashboard/hr/hr-dashboard']);
        } else {
          this.router.navigate([this.tenantId + '/dashboard']);
        }
        break;
      case 4:
        this.menuFlag = "ITM";
        if (this.currentUser.admin || roles.includes("RoleITAdministrator")) {
          this.router.navigate([this.tenantId + '/dashboard/itm/it-dashboard']);
        } else {
          this.router.navigate([this.tenantId + '/dashboard']);
        }
        break;
      case 5:
        this.menuFlag = "Adminstration";
        this.router.navigate([this.tenantId + '/dashboard']);
        break;
      case 6:
        this.menuFlag = "Home";
        this.router.navigate([this.tenantId + '/dashboard']);
        break;
      case 7:
        this.menuFlag = "My Approval";
        this.router.navigate([this.tenantId + '/dashboard']);
        break;
      case 8:
        this.menuFlag = "Finance";
        this.router.navigate([this.tenantId + '/dashboard']);
        break;
        case 9:
          this.menuFlag = "Recruit";
          this.router.navigate([this.tenantId + '/dashboard']);
          break;
    }

  }

  openCloseInnerSidebarsmaller() {
    this.sidebarsmaller = !this.sidebarsmaller;
    this.sidebarbigger = !this.sidebarbigger
  }

  openNotAuthorizedSnackbar() {
    this.snackbar.open('You are not authorized to perform this action', 'Close', {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  isPermitted(menuId) {
    if (menuId === 6) return true; // Home always allowed
    let roles = this.currentUser.roles || [];

    // Role Permissions Mapping
    const permissionMap: Record<number, string[]> = {
      1: ['Administrator', 'RolePmoAdministrator', 'RolePmoUser'], //for PMO switch(1)
      2: ['Administrator', 'RoleCrmAdministrator', 'RoleCrmUser'], //for CRM switch(2)
      3: ['Administrator', 'RoleHrmAdministrator', 'RoleNDATeam', 'RoleHrmUser'], //for HRM switch(3)
      4: ['Administrator', 'RoleITAdministrator', 'RoleITUser', 'RoleHelpdeskUser'], //for ITM switch(4)
      5: ['Administrator', 'RoleAdministrator', 'RoleAdministrationUser'], //for Admin switch(5)
      7: ['Administrator', 'RoleAdministrator', 'RoleApprover'], //for Approval switch(7)
      8: ['Administrator', 'RoleFinanceAdministrator', 'RoleFinanceUser'],//for finance switch(8)
      9: ['Administrator', 'RoleHrmAdministrator'], //for Recruit switch(9)
    };

    return this.currentUser.admin || permissionMap[menuId]?.some(role => roles.includes(role));
  }
}

  // isPermitted(switchcase) {
  //   let roles = this.currentUser.roles;
  //   switch (switchcase) {
  //     case 1:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RolePmoAdministrator") ||
  //         roles.includes("RolePmoUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 2:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleCrmAdministrator") ||
  //         roles.includes("RoleCrmUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 3:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleHrmAdministrator") || roles.includes("RoleNDATeam") ||
  //         roles.includes("RoleHrmUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 4:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleITAdministrator") ||
  //         roles.includes("RoleITUser") || roles.includes("RoleHelpdeskUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 5:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleAdministrator") || roles.includes("RoleAdministrationUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 8:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleFinanceAdministrator") ||
  //         roles.includes("RoleFinanceUser")) {
  //         return true;
  //       }
  //       return false;
  //     case 6:
  //       // case for Home
  //       return true;
  //     case 7:
  //       if (this.currentUser.admin || roles.includes("Administrator") || roles.includes("RoleAdministrator") || roles.includes("RoleApprover")) {
  //         return true;
  //       }
  //       return false;
  //     default:
  //       return true;
  //   }
  // }

// }